<script lang="ts" setup></script>

<template>
  <a href="#main-content" class="skip-link">VAI AL CONTENUTO</a>
  <main>
    <slot />
  </main>
</template>

<style scoped>

</style>
